import merge from 'lodash-es/merge';
import get from 'lodash-es/get';
import getDefaultStyle from '../css/defaultStyle';

export function getDefaultControlStyle(control) {
  const instance = control.instance;
  const design = get(control,['options','lookAndFeel','controlsDesign'],'classic');
  if (!getDefaultControlStyle[control.designMode]) {
    getDefaultControlStyle[control.designMode]={};
  }

  if (!getDefaultControlStyle[instance.args.designMode][design]) {
    getDefaultControlStyle[instance.args.designMode][design] = {
      normal: merge({}, getDefaultStyle(), {
        position: 'absolute',
        cursor: 'pointer',
        transitionTimingFunction: 'ease',
        transitionDelay: '0s',
        boxSizing: 'border-box',
        top: '8px',
        left: '8px',
        width: '136px',
        height: '32px',
        display: 'inline-block',
        margin: '0px',
      }),
      // active: {
      //   borderWidth: '1px',
      //   boxShadow: 'none',
      // },
      hover: {},
      body: {
        normal: merge({}, getDefaultStyle(), {
          'transitionProperty': 'all',
          'transitionDuration': '${schemeAnimationDuration}',
          'transitionTimingFunction': 'ease',
          'transitionDelay': '0s',
          'padding': '${schemePaddingTop} calc(${schemeFontSize} * 2) 0 calc(${schemeFontSize} / 2)',
          'paddingLeft': 'calc(${schemeFontSize} / 2)',
          'paddingTop': '4px',
          'fontSize': '${schemeFontSize}',
          'fontWeight': '${schemeFontWeight}',
          'textAlign': 'center',
          'color': '${schemeForeground}',
          'textShadow': design=='classic'?'0 2px 2px ${schemeShade}':'0 0px 4px ${schemeShade}',
          'backgroundColor': '${schemeBackground}',
          'margin': '0px',
          'borderStyle': 'solid',
          'borderColor': '${schemeShade}',
          'borderWidth': design=='classic'?'2px':'0px',
          'borderRadius': design=='classic'?'8px':'4px',
          'boxShadow': design=='classic'?
            '0px 2px 4px rgba(0,0,0,0.4), 0 -12px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset'
            :'0px 2px 4px rgba(0,0,0,0.4)',
          // height: 'auto!important',
          'appearance': 'none',
          '-moz-appearance': 'none',
          '-webkit-appearance': 'none',
          'backgroundPosition': 'right 4px center',
          'backgroundImage': 'none',
          // "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABYAAAAUCAYAAACJfM0wAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAB3RJTUUH4QcOFh4TC2doZwAAABl0RVh0Q29tbWVudABDcmVhdGVkIHdpdGggR0lNUFeBDhcAAAKKSURBVDjLvZRPSFVBFMZ/Z+Z6fU+fT328FPwThEVkifTHRS2KkkAwddFGCAqDCHITGbRonRC2adXCXX/AEFqlG6OoRYsgaJHRJnPhIgq1MrXru/dOC+fZ9Ho+oUUDHzN37rnfnXPmOx/85yEW/xwnRdbFAo1FKTLjzoVkCtB2BogduMTKQT4usjOA0QXBZUC5A69Ihp6NSwIJ+6wKM1POBxrwG1JUj/V4nUAWqAXSlsC3SNi9WiA71uN1NqSotu90PntVUIbyugrJdLeo4fE+7wzQCNQBNUDKosbuNY73eWe6W9RwXYVkbIYbB1UFpfCCiISnyPTuVEOjXV4/0AQ0APUWDUDTaJfX37tTDXmKTBD9URLBqeFGbYxBGcDXkhxoUxe/Bbrs6rPoKbBsYytvHdcnBtrUeS2iV0OzaszfNfbsQuyNhgZyuYiVpEdGi+ihDu9CQkvm2vPwJcDNY96RwQP6dP42cxErBnJAuJkqBJBchGqvk3B7Wtp9LUmA/fWye0e1pE61qD3n2tRJLeslXM6ZxSez8Z370/GrIOI76z8wLvGGnIII8/B9PNOcli+7aqU94UmlFlGtWWnct02ay5RogG+B+fzgXTxydiJ8FER8BX7aUxusPFyNmnxDTHyI55rTMt+alYO+lqQSUer3SRfuTccjl6bCx8AC8MM9bSGx25oREE3OxHNNVfJpb1Y6ymxZVnJm8e7beHhwKpwE5h1Stzs3Jc63cTgxE8+mfN4cqpfDYczS7dfR5SvrKlm0SgkcUkMJwxFH136VT3JpjfIbR/UOgOsvoo9VPsHSGqvAWjFSSlijONBWlvnsIntJkUNoStlmKa9116bAIs1WfryVoRfz3v8/fgH1ONhBgodkdQAAAABJRU5ErkJggg==')",
          'backgroundRepeat': 'no-repeat',
          'position': 'absolute',
          'top': '0px',
          'right': '0px',
          'bottom': '0px',
          'left': '0px',
          'height': '100%',
          'width': '100%',
        }),
        focused: {
          borderColor: 'rgba(0,0,0,0.25)',
        },
        hover: {
          backgroundColor: '${schemeBackgroundHover}',
          boxShadow: design=='classic'?
            '0px 2px 2px rgba(0,0,0,0.4), 0 -8px 20px ${schemeShade} inset,  0 2px 3px #ffffff inset'
            :'0px 2px 2px rgba(0,0,0,0.4)',
        },
      },
      icon: {
        normal: merge({}, getDefaultStyle(), {
          transitionProperty: 'all',
          transitionDuration: '${schemeAnimationDuration}',
          transitionTimingFunction: 'ease',
          transitionDelay: '0s',
          color: '${schemeForeground}',
          fontSize: '${schemeFontSize}',
          fontWeight: '${schemeFontWeight}',
          width: '24px',
          height: '24px',
          position: 'absolute',
          right: 'calc(${schemeFontSize} / 2)',
          top: 'calc(50% - ${schemeFontSize} / 2)',
          pointerEvents: 'none',
          textAlign: 'center',
          // opacity: '0.7',
        }),
        hover: {
          opacity: '1',
        },
        url: '',
      },
    };
  }

  return getDefaultControlStyle[instance.args.designMode][design];
}

export function getDefaultControl(instance) {
  var cmb = document.createElement('div');
  cmb.classList.add('controls');
  var inner = '<select class="body"></select><div class="icon">▼</div>';
  cmb.innerHTML = inner;
  return cmb;
}
